import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import { BiRightArrowAlt } from 'react-icons/bi'
import { GiHockey } from 'react-icons/gi'

import Loader from '../components/Loader'

import DepthChartModal from '../components/modal/DepthChart'
import {
  clearDepthChart,
  getActiveRosterCount,
  getOtherTeamLine,
  getTeamBench,
} from '../redux/actions/depthChartAction'
import { useSelector } from 'react-redux'
import { activeRosterCount, isLocked, nonActivePlayers } from '../config/constants'
import { MdLock } from 'react-icons/md'
import { useLocation, useParams } from 'react-router-dom'
import ConfirmationModal from '../components/modal/ConfirmationModal'
import MainHeader from '../components/MainHeader'

const mockData = [
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line1-1',
    Position: 'LW',
    bgImage: require('../assets/interface/w.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line1-2',
    Position: 'C',
    bgImage: require('../assets/interface/c.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Center',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line1-3',
    Position: 'RW',
    bgImage: require('../assets/interface/w.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'pairing1-1',
    Position: 'D',
    bgImage: require('../assets/interface/d.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'pairing1-2',
    Position: 'D',
    bgImage: require('../assets/interface/d.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'goalie',
    Position: 'G',
    bgImage: require('../assets/interface/g.png'),
    imageUrl: require('../assets/goalie-player.jpeg'),
    positionName: 'Goalie',
  },

  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line2-1',
    Position: 'LW',
    bgImage: require('../assets/interface/w.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line2-2',
    Position: 'C',
    bgImage: require('../assets/interface/c.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Center',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line2-3',
    Position: 'RW',
    bgImage: require('../assets/interface/w.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'pairing2-1',
    Position: 'D',
    bgImage: require('../assets/interface/d.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'pairing2-2',
    Position: 'D',
    bgImage: require('../assets/interface/d.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },

  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line3-1',
    Position: 'LW',
    bgImage: require('../assets/interface/w.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line3-2',
    Position: 'C',
    bgImage: require('../assets/interface/c.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Center',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line3-3',
    Position: 'RW',
    bgImage: require('../assets/interface/w.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'pairing3-1',
    Position: 'D',
    bgImage: require('../assets/interface/d.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'pairing3-2',
    Position: 'D',
    bgImage: require('../assets/interface/d.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },

  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line4-1',
    Position: 'LW',
    bgImage: require('../assets/interface/w.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line4-2',
    Position: 'C',
    bgImage: require('../assets/interface/c.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Center',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'line4-3',
    Position: 'RW',
    bgImage: require('../assets/interface/w.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    firstName: '',
    lastName: '',
    name: '',
    classKey: 'pairing4-1',
    Position: 'D',
    bgImage: require('../assets/interface/d.png'),
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
]

const TeamLine = () => {
  const USER = useSelector((state) => state?.user)
  const [data, setData] = useState(mockData)
  const [benchData, setBenchData] = useState([])
  const [loading, setLoading] = useState(true)
  const [openModal, setOpenModal] = useState(false)
  const [modalData, setModalData] = useState(null)
  const [activeCount, setActiveCount] = useState(0)
  const [weekProjection, setWeekProjection] = useState('')
  const [clearBtnLoading, setClearBtnLoading] = useState(false)

  const { teamId } = useParams()
  const { state } = useLocation()

  useEffect(() => {
    getData()
  }, [USER?.setting?.date, teamId])

  const getData = async () => {
    const filtered = [...mockData]
    const lp1 = ['line1-1', 'line1-2', 'line1-3', 'goalie', 'pairing1-1', 'pairing1-2']
    const lp2 = ['line2-1', 'line2-2', 'line2-3', 'pairing2-1', 'pairing2-2']
    const lp3 = ['line3-1', 'line3-2', 'line3-3', 'pairing3-1', 'pairing3-2']
    const lp4 = ['line4-1', 'line4-2', 'line4-3', 'pairing4-1']
    setLoading(true)

    const res = teamId
      ? await getOtherTeamLine({ date: USER?.setting?.date, team: teamId })
      : await getActiveRosterCount({ date: USER?.setting?.date, team: null })

    if (res) {
      setActiveCount(res?.count)
      setWeekProjection(res?.weekProjection)
      if (res?.data?.length > 0) {
        res?.data.map((item) => {
          let index = filtered.findIndex((item2) => item2.classKey === item.classKey)

          const imageUrl = item?.player?.player_id?.HostedHeadshotNoBackgroundUrl
          const name = item?.player?.player_id?.Name
          const firstName = item?.player?.player_id?.FirstName
          const lastName = item?.player?.player_id?.LastName
          const isPlayerLocked = item?.player?.isPlayerLocked
          const _id = item?.player?.player_id?._id
          const opponent = item?.player?.player_id?.Opponent
          const team = item?.player?.player_id?.Team
          const injuryStatus = item?.player?.player_id?.InjuryStatus

          if (index !== -1) {
            filtered.splice(index, 1, {
              imageUrl: imageUrl || filtered[index].imageUrl,
              Name: name,
              FirstName: firstName,
              LastName: lastName,
              Opponent: opponent,
              Team: team,
              InjuryStatus: injuryStatus,
              Position: filtered[index].Position,
              positionName: filtered[index].positionName,
              classKey: filtered[index].classKey,
              bgImage: filtered[index].bgImage,
              type: filtered[index].type,
              isPlayerLocked: isPlayerLocked ? isPlayerLocked : false,
              _id: _id ? _id : false,
            })
          }
        })

        setData({
          lp1Arr: filtered?.filter((v) => lp1.includes(v?.classKey)),
          lp2Arr: filtered?.filter((v) => lp2.includes(v?.classKey)),
          lp3Arr: filtered?.filter((v) => lp3.includes(v?.classKey)),
          lp4Arr: filtered?.filter((v) => lp4.includes(v?.classKey)),
        })
      } else {
        setData({
          lp1Arr: filtered?.filter((v) => lp1.includes(v?.classKey)),
          lp2Arr: filtered?.filter((v) => lp2.includes(v?.classKey)),
          lp3Arr: filtered?.filter((v) => lp3.includes(v?.classKey)),
          lp4Arr: filtered?.filter((v) => lp4.includes(v?.classKey)),
        })
      }
      // const response = await getTeamBench({ date: USER?.setting?.date, team: null })
      // if (response) {
      //   setBenchData(response)
      // }
    }
    setLoading(false)
  }

  const clearDepthChartRoster = async () => {
    setClearBtnLoading(true)
    let playerIds = []
    const totalArr = [...data?.lp1Arr, ...data?.lp2Arr, ...data?.lp3Arr, ...data?.lp4Arr]
    totalArr?.forEach((v) => {
      if (!v?.isPlayerLocked && v?._id) {
        playerIds.push(v?._id)
      }
    })
    const res = await clearDepthChart({
      ids: playerIds,
    })
    setClearBtnLoading(false)
    if (res) {
      await getData()
    }
  }

  const handleCard = (data) => {
    const check = () => {
      if (isLocked()) return false
      if (data?.isPlayerLocked) return false
      if (!data?.isPlayerLocked) return true
    }

    if (check()) {
      setOpenModal(true)
      setModalData(data)
    }
  }

  return (
    <div className='time_line_container'>
      <MainHeader />

      {teamId && (
        <div className='viewing_roster_heading'>
          <h2>Your are viewing {state?.teamName || data?.lp1[0]?.Team} line up.</h2>
        </div>
      )}

      {USER?.setting?.date == USER?.currentDate && !teamId && (
        <div className='clear_button_box'>
          <ConfirmationModal
            onClick={clearDepthChartRoster}
            content={{
              title: 'ARE YOU SURE?',
              mainButton: {
                disbaled: activeCount != activeRosterCount,
                text: 'Clear Team Line',
              },
              submitButton: {
                disbaled: activeCount != activeRosterCount,
                text: 'Confirm',
                loading: clearBtnLoading,
              },
            }}
          />
          {/* <Button
            disabled={activeCount != activeRosterCount}
            loading={clearBtnLoading}
            type='primary'
            onClick={clearDepthChartRoster}
          >
            Clear Team Line
          </Button> */}
        </div>
      )}

      {loading ? (
        <Loader />
      ) : (
        <section className='body_wrapper'>
          <div className='body_content'>
            <div
              className='overlay'
              style={{
                display: !teamId && activeCount != activeRosterCount ? 'flex' : 'none',
              }}
            >
              <h2>{`You have illegal Lineup`}</h2>
              <h4>{`kindly have ${activeRosterCount} players and ${nonActivePlayers} non active players on the roster`}</h4>
            </div>
            <div className='body_content_top'>
              <img className='team_line_bg' src={require('../assets/team-line-bg.png')} />
              {data?.lp1Arr?.map((v) => {
                return (
                  <>
                    {v?.isPlayerLocked && (
                      <div className={`tl_big_card_overlay ${v?.classKey}`}>
                        <MdLock size={40} color={'#fff'} />
                      </div>
                    )}
                    <div
                      key={v?.classKey}
                      className={`tl_big_card ${v?.classKey}`}
                      onClick={() => !teamId && handleCard(v)}
                      style={{ cursor: teamId ? 'no-drop' : 'pointer' }}
                    >
                      <img src={v?.bgImage} />
                      <div className='content'>
                        <div className='image_box'>
                          <img src={v?.imageUrl} />
                        </div>
                        <p className='player_name'>
                          {v?.FirstName ? `${v?.FirstName?.[0]}. ${v?.LastName}` : '-'}
                        </p>
                        <div className='_bottom'>
                          <p>{v?.Opponent || '-'}</p>
                          <p>{v?.Team || '-'}</p>
                          <p>{v?.InjuryStatus || '-'}</p>
                        </div>
                      </div>
                    </div>
                  </>
                )
              })}
            </div>
            <div className='body_content_bottom'>
              <CardComponent
                data={data?.lp2Arr}
                heading={{
                  heading1: '2nd Line',
                  heading2: '2nd Pair',
                }}
                onClick={handleCard}
              />
              <CardComponent
                data={data?.lp3Arr}
                heading={{
                  heading1: '3rd Line',
                  heading2: '3rd Pair',
                }}
                onClick={handleCard}
              />
              <CardComponent
                data={data?.lp4Arr}
                heading={{
                  heading1: '4th Line',
                  heading2: '',
                }}
                onClick={handleCard}
              />
            </div>
            {/* <div className='bench_player_container'>
              <div className='bench_player_box'>
                <header>
                  <h3>Team Bench</h3>
                  <p>
                    View All <BiRightArrowAlt size={18} />
                  </p>
                </header>
                <section className='bench_player_body'>
                  {benchData?.map((v, i) => {
                    return (
                      <div key={i} className='bench_player_card'>
                        <div className='left'>
                          {v?.player_id?.HostedHeadshotNoBackgroundUrl ? (
                            <img src={v?.player_id?.HostedHeadshotNoBackgroundUrl} />
                          ) : (
                            <GiHockey size={50} color={'#fff'} />
                          )}
                        </div>
                        <div className='center'>
                          <div>
                            <p className='text1'>Team</p>
                            <p className='text2'>{v?.player_id?.Team || '-'}</p>
                          </div>
                          <div>
                            <p className='text1'>Pos</p>
                            <p className='text2'>{v?.player_id?.Position || '-'}</p>
                          </div>
                          <div>
                            <p className='text1'>Player</p>
                            <p className='text2'>{v?.player_id?.Name || '-'}</p>
                          </div>
                          <div>
                            <p className='text1'>Status</p>
                            <p className='text2'>{v?.player_id?.InjuryStatus || '-'}</p>
                          </div>
                          <div>
                            <p className='last_text'>
                              Opponent & <br /> Gametime
                            </p>
                            <p className='text2'>{v?.player_id?.Opponent || '-'}</p>
                          </div>
                        </div>
                        <div className='right'>
                          <p>Week</p>
                          <p>Projections</p>
                          <h4>{v?.player_id?.Projection || '-'}</h4>
                        </div>
                      </div>
                    )
                  })}
                </section>
              </div>
            </div> */}
          </div>
        </section>
      )}

      <DepthChartModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        data={modalData}
        getDepthChartData={getData}
      />
    </div>
  )
}

const CardComponent = ({ data, heading, onClick }) => {
  const { teamId } = useParams()
  return (
    <div className='card_box'>
      <div className='header'>
        <p className='heading1'>{heading?.heading1}</p>
        <p className='heading2'>{heading?.heading2}</p>
      </div>
      <div className='player_card_box'>
        {data?.map((v) => {
          return (
            <div className='card_wrapper' key={v?.classKey}>
              {v?.isPlayerLocked && (
                <div className={`tl_small_card_overlay`}>
                  <MdLock size={25} color={'#fff'} />
                </div>
              )}
              <div
                className='tl_small_card'
                onClick={() => !teamId && onClick(v)}
                style={{ cursor: teamId ? 'no-drop' : 'pointer' }}
              >
                <img src={v?.bgImage} />
                <div className='content-s'>
                  <div className='image_box'>
                    <img src={v?.imageUrl} />
                  </div>
                  <p className='player_name'>
                    {' '}
                    {v?.FirstName ? `${v?.FirstName?.[0]}. ${v?.LastName}` : '-'}
                  </p>
                  <div className='_bottom'>
                    <p>{v?.Opponent || '-'}</p>
                    <p>{v?.Team || '-'}</p>
                    <p>{v?.InjuryStatus || '-'}</p>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TeamLine
